import { render, staticRenderFns } from "./messageLst.vue?vue&type=template&id=caf04aea&"
import script from "./messageLst.vue?vue&type=script&lang=js&"
export * from "./messageLst.vue?vue&type=script&lang=js&"
import style0 from "./messageLst.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports